import './ProfilePage.css';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-phone-number-input/style.css';

import { Auth } from '../services/AuthService';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';

import { Parameters } from '../components/profile/Parameters';
import { ProfileCard } from '../components/profile/ProfileCard';
import { MyProfile } from '../components/profile/MyProfile';
import { AppPage } from '../AppContent';
import { MyChecklists } from '../components/profile/MyChecklists';
import { useTags, useUserInformations } from '../hooks/WPHooks';
import { MyHobbies } from '../components/profile/MyHobbies';
import { IonIcon } from '@ionic/react';
import { logOutOutline, helpOutline } from 'ionicons/icons';
import { useHouseName } from '../hooks/HouseHooks';

interface ProfilePageProps extends RouteComponentProps {}

const ProfilePage: React.FC<ProfilePageProps> = () => {
  const { user, update } = useUserInformations();
  const { tags: hobbies } = useTags('interest');

  const houseName = useHouseName();

  const [loading, setLoading] = useState(false);

  const handleSignOut = (e: any) => {
    e.preventDefault();
    setLoading(true);
    Auth.signOut(true).finally(() => {
      // setLoading(false);
    });
    return false;
  };

  return (
    <AppPage>
      <div className="flex flex-col justify-between px-4 md:px-14 h-full xl:hidden">
        <div>
          <div className="bg-lightGrey overflow-hidden shadow rounded-3xl mt-4">
            <ProfileCard houseName={houseName} user={user} />
          </div>
          <ul className="py-6">
            <li className="py-1 my-3 cursor-pointer">
              <MyProfile houseName={houseName} user={user} update={update} />
            </li>
            <li className="py-1 my-3 cursor-pointer">
              <MyChecklists />
            </li>
            <li className="py-1 my-3 cursor-pointer">
              {user && <Parameters user={user} update={update} />}
            </li>
            <li className="py-1 my-3 cursor-pointer">
              {user && (
                <MyHobbies user={user} update={update} hobbies={hobbies} />
              )}
            </li>
            <li className="py-1 my-3 cursor-pointer">
              <a href="mailto:support@ciup.help">
                <div className="flex items-center text-black">
                  <div className="flex w-8 h-8 mr-4 inset-4 justify-center items-center border border-transparent rounded-full text-white bg-secondary ">
                    <IonIcon icon={helpOutline} />
                  </div>
                  <div>
                    <h4 className="text-black text-sm font-medium">
                      <FormattedMessage id="Need help ?" />
                    </h4>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div className="flex flex-col justify-center align-center mb-4">
          <a
            href="#logout"
            onClick={handleSignOut}
            className={`font-bold text-sm flex justify-center items-center ${
              loading === true ? 'text-lightGrey' : 'text-primary'
            }`}
          >
            <FormattedMessage id="Logout" />
            <IonIcon icon={logOutOutline} className="text-xl ml-2" />
          </a>

          <ul className="w-full flex flex-wrap justify-center px-6 mt-4">
            <li>
              <Link
                to="/pages/faq"
                className="text-black opacity-40 text-xs font-medium"
              >
                <FormattedMessage id="FAQ" />
              </Link>
            </li>
            <li>
              <Link
                to="/pages/policy"
                className="text-black opacity-40 text-xs font-medium ml-2"
              >
                <FormattedMessage id="Privacy Policy" />
              </Link>
            </li>
            <li>
              <Link
                to="/pages/legal"
                className="text-black opacity-40 text-xs font-medium ml-2"
              >
                <FormattedMessage id="Legal Notice" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </AppPage>
  );
};

export default ProfilePage;
